export default {
  '348c1bc18414a3cb6caaedd93ae37f83': '叫叫產品先學後付協議',
  c2a3ec7ebe84d8076ba62c0431543726:
    '歡迎您使用由成都書聲科技有限公司及指定的關聯公司（以下稱“書聲科技”或“我們”）提供的平台（包括叫叫的網站、APP、微信公眾號/服務號、微信小程序等，以下稱“叫叫平台”）的產品和服務。',
  '3dad1165e58a04cab22111fb37aec661':
    '請您（以下也稱“用户”）於使用叫叫平台的產品和服務前認真閲讀並充分理解本協議的全部內容，您對我們產品的使用行為，或您點擊【同意簽約】本協議的按鈕，即視為您已經全文閲讀並充分理解和自願接受本協議之全部內容，本協議即在您和我們之間正式訂立並即時生效，形成對雙方均具有拘束力的法律文件。',
  '05a1f04bce4992787778fb3923f2b5d4': '一、服務協議的確認和接納',
  dea20338e4512e2931254cec541f41d1:
    '1．本協議是用户與我們之間關於使用叫叫平台服務的協議，為《用户服務協議》的補充協議。如本協議與上述協議存在衝突的，以本協議約定為準。',
  abd20b27581a139f46563dab81ec1814:
    '2．您確認，您具備與您在叫叫平台開展行為（包括但不限於訂立協議、購買平台產品或服務等）相適應的民事行為能力。',
  f1c6fc504b9ed854feb45f33ff33d4b4:
    '若您未滿十八週歲或存在其他不具備與您行為相適應的民事行為能力的情形，則應在您的法定監護人的監護下、或同意後再使用叫叫平台服務。未成年人行使和履行本協議項下的權利和義務視為已獲得法定監護人的認可，本協議對您及您的法定監護人產生法律約束力。',
  '8a7461caf35f6da01a7240620e65e9a8':
    '3．請您理解，我們有權根據法律法規、業務發展情況調整(包括取消、新增、減少等)付費的類型、額度和產品權益，我們將以合理方式公佈和/或向您發送通知，我們建議請您仔細閲讀。我們將盡力確保上述調整不會損害會員已有利益，如您對調整有異議，請您聯繫我們的客服。當您繼續使用產品的，即表明您同意接受相應調整。如您不同意前述調整內容的，請您立即停止使用服務。',
  '91af00ef3e2f2d25afac149d1c40252f': '二、關於先學後付服務',
  c62d21d6144c9f7376bb428f1353fe1d:
    '1．您簽約的服務為叫叫全年系統包先學後付服務。您可選擇在首月試學（以下簡稱“試學”）過程中，或在試學結束滿意後付費購買產品。',
  '499a29d94731ad31bd6d97449b42e42a':
    '2．成功簽約後，您將享受除實物外的全部權益，實物贈品將在付費購買產品後發放。先學後付產品不支持調整解鎖計劃。',
  '1f849e78b08f84d7d0621a6632472bbe':
    '3．試學結束後 7 天內，若您未付費，您的訂單將被關閉，對應的產品服務和權益亦將被移除。',
  '2c9036dd1d553a9846fd140ab47e7f7f': '上劃查看全部協議',
  '61f13eff4e81ce7b5f9e1ae248265679': '同意簽約'
};
